<template>
  <!-- Single select -->
  <Select
    v-if="isSingle"
    :model-value="local ? String(local) : undefined"
    @update:model-value="onSingleChange"
  >
    <SelectTrigger @clear="onSingleChange(null)">
      <SelectValue :placeholder="item.placeholder || ''" />
    </SelectTrigger>
    <SelectContent>
      <SelectItem v-for="opt in item.enums" :key="opt" :value="String(opt)">
        {{ opt }}
      </SelectItem>
    </SelectContent>
  </Select>

  <!-- Multiple select -->
  <Popover v-else>
    <PopoverTrigger as-child>
      <button
        type="button"
        class="flex min-h-9 w-full items-center justify-between rounded-md border border-input bg-transparent px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-ring"
      >
        <div class="flex flex-wrap gap-1">
          <template v-if="local && local.length">
            <span
              v-for="val in local"
              :key="val"
              class="inline-flex items-center rounded-md bg-muted px-2 py-0.5 text-xs font-medium"
            >
              {{ val }}
            </span>
          </template>
          <span v-else class="text-muted-foreground">
            {{ item.placeholder || "" }}
          </span>
        </div>
      </button>
    </PopoverTrigger>
    <PopoverContent
      class="w-[var(--reka-popover-trigger-width)] p-2"
      align="start"
    >
      <div class="flex flex-col gap-1 max-h-60 overflow-y-auto">
        <label
          v-for="opt in item.enums"
          :key="opt"
          class="flex items-center gap-2 rounded-md px-2 py-1.5 text-sm cursor-pointer hover:bg-accent"
        >
          <Checkbox
            :checked="local && local.includes(String(opt))"
            @update:checked="(checked) => onMultiToggle(String(opt), checked)"
          />
          {{ opt }}
        </label>
      </div>
    </PopoverContent>
  </Popover>
</template>

<script>
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/ui/select";
import { Popover, PopoverTrigger, PopoverContent } from "@/shared/ui/popover";
import { Checkbox } from "@/shared/ui/checkbox";

export default {
  components: {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
    Popover,
    PopoverTrigger,
    PopoverContent,
    Checkbox,
  },
  props: {
    item: { type: Object, required: true },
  },
  data() {
    const raw = this.item.value;
    const isSingle = this.item.type === "string";
    let local;
    if (isSingle) {
      local = raw ?? "";
    } else {
      local = Array.isArray(raw) ? raw.map(String) : [];
    }
    return { local };
  },
  computed: {
    isSingle() {
      return this.item.type === "string";
    },
  },
  methods: {
    onSingleChange(val) {
      this.local = val || "";
      this.$emit("update", this.item.key, this.local ? this.local : null);
    },
    onMultiToggle(opt, checked) {
      if (!Array.isArray(this.local)) this.local = [];
      if (checked) {
        if (!this.local.includes(opt)) {
          this.local = [...this.local, opt];
        }
      } else {
        this.local = this.local.filter((v) => v !== opt);
      }
      this.$emit(
        "update",
        this.item.key,
        this.local.length ? this.local : null
      );
    },
  },
};
</script>
